import React from "react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { faqsCommon } from "@/data/faqs";

export function HomeFAQ({ t, lang }) {
  return (
    <section className="max-w-[1120px] mx-auto px-4 sm:px-6 mt-14">
      <h2 className="text-2xl sm:text-3xl font-semibold text-[hsl(var(--brand-navy))]">{t("home.faq_title")}</h2>
      <Accordion type="single" collapsible className="mt-4" data-testid="home-faq-accordion">
        {faqsCommon.map((f) => (
          <AccordionItem key={`faq-home-${f.q_it}`} value={`faq-home-${f.q_it}`}>
            <AccordionTrigger className="text-left text-sm sm:text-base">{lang === "it" ? f.q_it : f.q_en}</AccordionTrigger>
            <AccordionContent className="text-sm text-[hsl(var(--muted-foreground))]">{lang === "it" ? f.a_it : f.a_en}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}

export default HomeFAQ;
